import { render, staticRenderFns } from "./ServiceBtns.vue?vue&type=template&id=3a1a7450&"
import script from "./ServiceBtns.vue?vue&type=script&lang=js&"
export * from "./ServiceBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports